import React, {createContext, useContext, useEffect, useState} from 'react';
export const THEME_KEY='addanote.theme.v1';
const valid=value=>['light','dark','system'].includes(value);
export function readTheme(){try{const value=localStorage.getItem(THEME_KEY);return valid(value)?value:'system';}catch{return 'system';}}
export function applyTheme(preference){
 const dark=preference==='dark' || (preference==='system' && typeof window.matchMedia==='function' && window.matchMedia('(prefers-color-scheme: dark)').matches);
 document.documentElement.dataset.theme=dark?'dark':'light';
 document.documentElement.style.colorScheme=dark?'dark':'light';
 const meta=document.querySelector('meta[name="theme-color"]');if(meta)meta.content=dark?'#111827':'#ffffff';
}
const ThemeContext=createContext({preference:'system',setPreference:()=>{}});
export function ThemeProvider({children}){
 const [preference,setValue]=useState(readTheme);
 const setPreference=value=>{if(!valid(value))return;try{localStorage.setItem(THEME_KEY,value);}catch{}applyTheme(value);setValue(value);};
 useEffect(()=>{
  applyTheme(preference);
  const media=typeof window.matchMedia==='function'?window.matchMedia('(prefers-color-scheme: dark)'):null;
  const update=()=>applyTheme(preference);
  if(media?.addEventListener)media.addEventListener('change',update);else media?.addListener?.(update);
  return()=>{if(media?.removeEventListener)media.removeEventListener('change',update);else media?.removeListener?.(update);};
 },[preference]);
 useEffect(()=>{const sync=event=>{if(event.key===THEME_KEY || event.key===null){const value=readTheme();applyTheme(value);setValue(value);}};window.addEventListener('storage',sync);return()=>window.removeEventListener('storage',sync);},[]);
 return <ThemeContext.Provider value={{preference,setPreference}}>{children}</ThemeContext.Provider>;
}
export function ThemeControl({label='Appearance'}){
 const {preference,setPreference}=useContext(ThemeContext);
 return <label className="theme-control"><span>{label}</span><select className="form-control" value={preference} onChange={e=>setPreference(e.target.value)}><option value="system">System</option><option value="light">Light</option><option value="dark">Dark</option></select></label>;
}
